import {DisableMobileApplicationRequestStatusEnum} from '@/services/api-clients';

export function disableMobileApplicationRequestStatusColorFilter(status: DisableMobileApplicationRequestStatusEnum): string {
  switch (status) {
    case DisableMobileApplicationRequestStatusEnum.Pending: return 'warning';
    case DisableMobileApplicationRequestStatusEnum.Finished: return 'error';
  }
}
